import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import {
  Button,
  Col,
  Form,
  Grid,
  Input,
  message,
  Modal,
  Row,
  Select,
  Upload,
  Card,
  Checkbox,
  Radio,
  Image,
  DatePicker,
  DatePickerProps,
} from 'antd';
import type { UploadFile, UploadProps } from 'antd/es/upload/interface';
import {
  LoadingOutlined,
  UploadOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import Layout from '../../../layouts/User';
import {
  getPostalCodes,
  getCities,
  getSubCities,
  getStates,
  getSexes,
} from '../../../services/api';
import styles from '../index.module.scss';
import UploadService from '../../../services/upload';
import CompressImageService from '../../../services/upload';
import ServiceAreaInput from '../../../components/ServiceAreaInput/ServiceAreaInput';
import type {
  ServiceAreaType,
  ServiceAreaRefType,
} from '../../../components/ServiceAreaInput/ServiceAreaInput';
import moment from 'moment';
import {
  validatePhoneNumber,
  validateNumberOnly,
  checkValidateCitizen,
} from '../../../functions';
import UploadImages from './UploadImages';
import MUIDatePicker from '../../../components/MaterialUI/DatePicker';
import { getLocalUrl } from '../../../functions';
import dayjs from 'dayjs';
import { log } from 'console';
import 'moment/locale/th';
import locale from 'antd/es/date-picker/locale/th_TH';

interface IApplyJob {
  serviceCategory: string[];
  topic: string;
  description: string;
  name: string;
  phone: string;
  address?: string;
  province?: string;
  district?: string;
  subDistrict?: string;
  postCode?: string;
  services: any;
  idCard: string;
  status: string;
}

interface ICriminal {
  nameTitle: string;
  firstName: string;
  lastName: string;
  oldFirstName: string;
  oldLastName: string;
  idCardNo?: string;
  gender?: string;
  district?: string;
  subDistrict?: string;
  postCode?: string;
  services: any;
  idCard: string;
  status: string;
}

// interface ProvinceOption {
//   label: string;
//   value: string;
// }

enum FOLDER_TYPE {
  CRIMINAL = 'criminal',
}

export type Props = {};

const ServiceApplyJob: React.FC<Props> = (props) => {
  const { Option } = Select;
  const [form] = Form.useForm();
  const { useBreakpoint } = Grid;
  const breakpoints = useBreakpoint();
  const navigate = useNavigate();
  const areaInputRef = useRef<ServiceAreaRefType>(null);

  const [blockButton, setBlockbutton] = useState(false);
  const [serviceAreas, setServiceAreas] = useState<ServiceAreaType[]>([]);
  // const [province, setProvince] = useState('');
  // const [provinces, setProvinces] = useState<ProvinceOption[]>([]);
  // const [categoryFileList, setCategoryFileList] = useState<UploadFile[]>([]);
  const [idFileList, setIdFileList] = useState<UploadFile[]>([]);
  const [idCardFileVerified, setIdCardFileVerified] = useState<UploadFile[]>(
    []
  );
  const [loading, setLoading] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [serviceCategoryOptions, setServiceCategoryOptions] = useState<any>([]);
  const [selectedServiceCategory, setSelectedServiceCategory] = useState<any>(
    []
  );
  const [filesServices, setFilesServices] = useState();
  const user = useSelector((state: any) => state.user);
  const [currentUser, setCurrentUser] = useState<any>({});
  const [applyJobData, setApplyJobData] = useState<IApplyJob>();
  const [criminalRecordData, setCriminalRecordData] = useState<ICriminal>();
  const [editId, setEditId] = useState<any>('');
  const [applyJobAreaId, setApplyJobAreaId] = useState<any>('');
  const [mode, setMode] = useState<string>('CREATE');
  const [modeCriminal, setModeCriminal] = useState<string>('CREATE');
  const [postalCodes, setPostalCodes] = useState<any>([]);
  const [postalCodesCriminal, setPostalCodesCriminal] = useState<any>([]);
  const [subCities, setSubCities] = useState<any>([]);
  const [subCitiesCriminal, setSubCitiesCriminal] = useState<any>([]);
  const [cities, setCities] = useState<any>([]);
  const [citiesCriminal, setCitiesCriminal] = useState<any>([]);
  const [states, setStates] = useState<any>([]);
  const [statesCriminal, setStatesCriminal] = useState<any>([]);
  const [showConfirmUpdate, setShowConfirmUpdate] = useState<boolean>(false);
  const [isCriminal, setIsCriminal] = useState<boolean>(false);
  const [selectedDate, handleDateChange] = useState<any>(
    moment().add(0, 'year')
  );
  const [sexes, setSexes] = useState<any>([]);
  const [ageConvert, setAgeConvert] = useState<any>(0);
  const [idCardfileUrl, setIdCardFileUrl] = useState<any>();
  const [verifiedImageUrl, setVerifiedImageUrl] = useState<any>();

  const [idCardfile, setIdCardFile] = useState<any>({
    url: null,
    raw: null,
  });
  const [verifiedImage, setVerifiedImage] = useState<any>({
    url: null,
    raw: null,
  });
  const [isExistingCriminalRecord, setIsExistingCriminalRecord] =
    useState(false);

  const dateFormat = 'DD/MM/YYYY';

  const serviceCategoryList = [
    {
      label: 'ระบบไฟฟ้า',
      value: 'electrical',
    },
    {
      label: 'ระบบประปา',
      value: 'water',
    },
    {
      label: 'งานปูน/พื้น/กระเบื้อง',
      value: 'floor',
    },
    {
      label: 'งานฝ้า/หลังคา',
      value: 'ceiling',
    },
    {
      label: 'งานทาสี',
      value: 'paint',
    },
    {
      label: 'งานเหล็ก/อลูมิเนียม/ไม้',
      value: 'aluminium',
    },
    {
      label: 'ผู้รับเหมา',
      value: 'contractor',
    },
    {
      label: 'ออกแบบ/สถาปนิก',
      value: 'architect',
    },
  ];

  const isLoading = useSelector(() => loading || isUploading);

  const getServiceCategoryOptions = async () => {
    let data = [];
    for (let item of serviceCategoryList) {
      data.push({
        label: item.label,
        value: item.value,
      });
    }
    setServiceCategoryOptions(data);
  };

  const getApplyJobData = async () => {
    const { data } = await axios.get(`/applyJobs/user/${currentUser._id}`);
    return data;
  };

  const getServiceJob = async (id: string) => {
    const { data } = await axios.get(`/order-service-jobs/applyJob/${id}`);
    return data;
  };

  const bindingApplyJobData = async () => {
    if (currentUser._id) {
      const { applyJob, applyJobArea, criminal } = await getApplyJobData();

      if (applyJob) {
        const existingAcceptJob = await getServiceJob(applyJob?._id);
        existingAcceptJob ? setMode('VIEW') : setMode('EDIT');
        setApplyJobData(applyJob);
        loadSubCities(applyJob.technician.postCode);
        loadCities(applyJob.technician.subDistrict);
        loadStates(applyJob.technician.district);
        setEditId(applyJob._id);
        setApplyJobAreaId(applyJobArea._id);
        setSelectedServiceCategory(applyJob.serviceCategory);
        setFilesServices(applyJob.services);
        setIdFileList([
          {
            name: 'image.png',
            url: applyJob.idCard,
            uid: '',
            status: 'done',
          },
        ]);
        form.setFieldsValue({
          idFileList: applyJob.idCard,
          services: applyJob.services,
        });
      }
      if (applyJobArea && applyJobArea.serviceAreas?.length) {
        setServiceAreas(applyJobArea.serviceAreas);
        areaInputRef.current?.populateData();
      }
      if (criminal) {
        setModeCriminal('EDIT');
        bindingCriminalData(criminal, applyJob);
      }
    }
  };

  const bindingCriminalData = (criminal: any, applyJob: any) => {
    //setIsCriminal

    form.setFieldsValue(criminal);
    loadSexes(criminal.gender);
    setCriminalRecordData(criminal);
    loadSubCitiesCriminal(criminal.address.postCode);
    loadCitiesCriminal(criminal.address.subDistrict);
    loadStatesCriminal(criminal.address.district);
    setIsCriminal(applyJob.isAllowCriminalChecked);
    // setIdCardFile(criminal.attachments.idCard)
    setIdCardFile({ url: criminal.attachments.idCard });
    setVerifiedImage({ url: criminal.attachments.verifiedImage });
    setIsExistingCriminalRecord(criminal.existingCriminalRecord);
    calculationBirthday(criminal.dob);

    form.setFieldsValue({
      criminal: {
        nameTitle: criminal.nameTitle,
        firstName: criminal.firstName,
        lastName: criminal.lastName,
        oldFirstName: criminal.oldFirstName,
        oldLastName: criminal.oldLastName,
        fatherName: criminal.fatherName,
        motherName: criminal.motherName,
        idCardNo: criminal.idCardNo,
        idCardConfirm: criminal.idCardNo,
        dob: moment(criminal.dob),
        gender: criminal.gender,
        phoneNo: criminal.phoneNo,
        email: criminal.email,
        lineId: criminal.lineId,
      },
      idCardCriminal: criminal.attachments.idCard,
      verifiedImage: criminal.attachments.verifiedImage,
    });
  };

  const toBuddhistYear = (moment: any, format: any) => {
    var christianYear = moment.format('YYYY');
    var buddhishYear = (parseInt(christianYear) + 543).toString();
    return moment
      .format(
        format
          .replace('YYYY', buddhishYear)
          .replace('YY', buddhishYear.substring(2, 4))
      )
      .replace(christianYear, buddhishYear);
  };

  const onIdImageChange: UploadProps['onChange'] = async ({ fileList }) => {
    // console.log('onIdImageChange.....', JSON.stringify(fileList));
    setIdFileList(fileList);
    form.setFieldsValue({
      idFileList: fileList,
    });
  };

  const idUploaderProps: UploadProps = {
    listType: 'picture-card',
    fileList: idFileList,
    onChange: (e) => {
      onIdImageChange(e);
    },
    maxCount: 1,
    multiple: false,
    beforeUpload: (file) => {
      const isImgFile = file.type === 'image/png' || file.type === 'image/jpeg';
      if (!isImgFile) {
        message.error(
          `${file.name} ฟอร์แมตไม่ถูกต้อง\nกรุณาอัพโหลดไฟล์​ .png หรือ .jpg`
        );
      }
      return isImgFile || Upload.LIST_IGNORE;
    },
    customRequest: ({ onSuccess }: any) => {
      onSuccess();
    },
  };

  //#region [load address master]
  const loadSubCities = async (value: any) => {
    setSubCities(await getSubCities(value));
  };

  const loadSubCitiesCriminal = async (value: any) => {
    setSubCitiesCriminal(await getSubCities(value));
  };

  const loadCities = async (value: any) => {
    setCities(await getCities(value));
  };

  const loadCitiesCriminal = async (value: any) => {
    setCitiesCriminal(await getCities(value));
  };

  const loadStates = async (value: any) => {
    setStates(await getStates(value));
  };

  const loadStatesCriminal = async (value: any) => {
    setStatesCriminal(await getStates(value));
  };
  //#endregion

  //#region [handle]
  const onPostalCodeChange = async (value: any) => {
    await loadSubCities(value);
    form.setFieldsValue({
      technician: {
        province: null,
        district: null,
        subDistrict: null,
      },
    });
    return;
  };

  const onPostalCodeCriminalChange = async (value: any) => {
    await loadSubCitiesCriminal(value);
    form.setFieldsValue({
      address: {
        province: null,
        district: null,
        subDistrict: null,
      },
    });
    return;
  };

  const onSubCityCriminalChange = async (value: any = null) => {
    await loadCitiesCriminal(value);
    form.setFieldsValue({
      address: {
        province: null,
        district: null,
      },
    });
    return;
  };

  const onCityCriminalChange = async (value: any = null) => {
    await loadStatesCriminal(value);
    form.setFieldsValue({
      address: {
        province: null,
      },
    });
    return;
  };

  const onGenderChange = async (value: any = null) => {
    form.setFieldsValue({
      criminal: {
        gender: null,
      },
    });
  };

  const onSubCityChange = async (value: any = null) => {
    await loadCities(value);
    form.setFieldsValue({
      technician: {
        province: null,
        district: null,
      },
    });
    return;
  };

  const onCityChange = async (value: any = null) => {
    await loadStates(value);
    form.setFieldsValue({
      technician: {
        province: null,
      },
    });
    return;
  };

  const initialPostalCode = async () => {
    setPostalCodes(await getPostalCodes());
  };

  const getSexesData = async () => {
    setSexes(await getSexes());
  };

  const loadSexes = async (id: any) => {
    const datas = await getSexes();
    const sexs = datas.filter((data: any) => data.value === id);
    setSexes(sexs);
  };

  const initialPostalCodeCriminal = async () => {
    setPostalCodesCriminal(await getPostalCodes());
  };

  const handleServiceCategoryChange = (value: string[]) => {
    setSelectedServiceCategory(value);
  };

  const handleShowUpdateBtnClick = (values: IApplyJob) => {
    if (mode === 'EDIT') {
      setShowConfirmUpdate(true);
    } else {
      handleApplyJob();
    }
  };

  const handleHideUpdateBtnClick = () => {
    setShowConfirmUpdate(false);
  };

  const handleApplyJob = async () => {
    const values = form.getFieldsValue();
    let images;
    try {
      setIsUploading(true);
      if (idFileList[0].name !== 'image.png') {
        const idImageUrls = await UploadService.uploadFile(idFileList);
        images = idImageUrls[0];
      } else {
        images = idFileList[0].url;
      }
    } catch (error: any) {
      message.error(error?.message);
    } finally {
      setIsUploading(false);
    }

    const requestBodyApplyJob = {
      ...values,
      idCard: images,
      status: 'waiting',
      serviceAreas,
      isAllowCriminalChecked: isCriminal,
      existingCriminalRecord: isExistingCriminalRecord,
      modeCriminal: modeCriminal,
      applyJobAreaId: applyJobAreaId,
      attachments: {
        idCard: idCardfileUrl,
        verifiedImage: verifiedImageUrl,
      },
    };

    console.log('requestBodyApplyJob....', requestBodyApplyJob);

    try {
      let res;
      if (mode === 'CREATE') {
        res = await axios.post('/applyJobs', requestBodyApplyJob);
        const { status } = res;
        if (status === 200) {
          message.success('สร้างประกาศงานสำเร็จ');
          navigate('/');
        }
      } else {
        res = await axios.patch(`/applyJobs/${editId}`, requestBodyApplyJob);
        const { status } = res;
        if (status === 200) {
          message.success('บันทึกประกาศงานสำเร็จ');
          navigate('/');
        }
      }
    } catch (error: any) {
      message.error(error?.message);
    } finally {
      setLoading(false);
    }
  };
  //#endregion

  const onChange: DatePickerProps['onChange'] = async (date, dateString) => {
    console.log(date, dateString);
    const age = await calculationBirthday(date);
    setAgeConvert(age);
    form.setFieldsValue({
      dob: date,
      age: age,
    });
  };

  // const toBuddhistYear = (moment: any, format: any) => {
  //   var christianYear = moment.format("YYYY");
  //   var buddhishYear = (parseInt(christianYear) + 543).toString();
  //   return moment
  //     .format(
  //       format
  //         .replace("YYYY", buddhishYear)
  //         .replace("YY", buddhishYear.substring(2, 4))
  //     )
  //     .replace(christianYear, buddhishYear);
  // };

  const onChangeBirthday = async (event: any) => {
    const age = await calculationBirthday(event);
    setAgeConvert(age);
    form.setFieldsValue({
      dob: event,
      age: age,
    });
  };

  const calculationBirthday = async (event: any) => {
    const dobs = moment(event).format('YYYY');
    const currentTime = moment(new Date()).format('YYYY');
    const age = parseInt(currentTime) - parseInt(dobs);
    setAgeConvert(age);
    form.setFieldsValue({
      age: age,
    });
    return age;
  };

  const onPreviewIdCard = (file: any) => {
    const url = getLocalUrl(file?.originFileObj);
    window.open(url, '_blank');
  };

  const onPreviewIdVerifiedCard = (file: any) => {
    const url = getLocalUrl(file?.originFileObj);
    window.open(url, '_blank');
  };

  const onUploadIdCardChange = async (e: any) => {
    if (e.file.status === 'done') {
      // console.log("file change...", e);
      const { originFileObj } = e.file;

      const url = getLocalUrl(originFileObj);
      setIdCardFile({ url, raw: originFileObj });
      const fileUrl = await uploadImage(originFileObj);
      setIdCardFileUrl(fileUrl);
      form.setFieldsValue({
        idCardCriminal: fileUrl,
      });
    }
  };

  const uploadImage = async (originFileObj: any) => {
    const imageSize: any = await resizeImage(originFileObj);
    const fmData = new FormData();
    const config = {
      headers: { 'content-type': 'multipart/form-data' },
    };

    fmData.append('images', blobToFile(imageSize, imageSize.name));
    fmData.append('path_name', FOLDER_TYPE.CRIMINAL);
    const fileRes = await axios.post(
      `/uploads//upload-image-resize`,
      fmData,
      config
    );

    return fileRes.data[0];
  };

  const blobToFile = (theBlob: any, fileName: any) => {
    return new File([theBlob], fileName, {
      lastModified: new Date().getTime(),
      type: theBlob.type,
    });
  };

  const resizeImage = async (file: any) => {
    const imageMaxHeight = 1024;
    const imageMaxWidth = 1024;
    const imageConvertSize = 2000000;

    const prepareImage = await CompressImageService.compressImage(
      file,
      imageMaxHeight,
      imageMaxWidth,
      imageConvertSize
    );
    return prepareImage;
  };

  const onUploadIdVerifiedCardChange = async (e: any) => {
    if (e.file.status === 'done') {
      // console.log("file change...", e);
      const { originFileObj } = e.file;

      const url = getLocalUrl(originFileObj);
      setVerifiedImage({ url, raw: originFileObj });

      const fileUrl = await uploadImage(originFileObj);
      setVerifiedImageUrl(fileUrl);
      form.setFieldsValue({
        verifiedImage: fileUrl,
      });
    }
  };

  //#region [useEffect]
  useEffect(() => {
    let isBlock =
      breakpoints.xs ||
      ((breakpoints.sm || breakpoints.md) && !breakpoints.lg) ||
      false;
    setBlockbutton(isBlock);
    getSexesData();
  }, [breakpoints]);

  useEffect(() => {
    initialPostalCode();
    getServiceCategoryOptions();
  }, []);

  useEffect(() => {
    initialPostalCodeCriminal();
  }, []);

  useEffect(() => {
    bindingApplyJobData();
  }, [currentUser]);

  useEffect(() => {
    if (user._id) {
      setCurrentUser(user);
    }
  }, [user]);

  useEffect(() => {
    form.setFieldsValue(applyJobData);
  }, [applyJobData]);

  useEffect(() => {
    form.setFieldsValue(criminalRecordData);
  }, [criminalRecordData]);

  //#endregion
  const onCheckCriminal = (event: any) => {
    setIsCriminal(!isCriminal);
    if (!event.target.checked) {
      resetCriminalForm();
    }
  };

  const resetCriminalForm = () => {
    setIdCardFile(null);
    setVerifiedImage(null);
    form.setFieldsValue({
      criminal: {
        nameTitle: '',
        firstName: '',
        lastName: '',
        oldFirstName: '',
        oldLastName: '',
        fatherName: '',
        motherName: '',
        idCardNo: '',
        idCardConfirm: '',
        dob: '',
        gender: '',
        phoneNo: '',
        email: '',
        lineId: '',
      },
      idCardfile: '',
      verifiedImage: '',
      age: '',
      address: {
        addressNo: '',
        postCode: '',
        subDistrict: '',
        district: '',
        province: '',
      },
    });
  };

  const changeExistingCriminalRecordValue = ({ target: { value } }: any) => {
    setIsExistingCriminalRecord(value);
  };

  const CriminalForm = () => {
    return (
      <>
        <Row gutter={[16, 16]}>
          <Col xs={24} md={4}>
            <Form.Item
              name={['criminal', 'nameTitle']}
              label='คำนำหน้า'
              rules={[
                {
                  required: isCriminal,
                  message: 'กรุณากรอกข้อมูล',
                },
              ]}
            >
              <Input
                placeholder='คำนำหน้าชื่อ'
                disabled={modeCriminal === 'EDIT'}
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={10}>
            <Form.Item
              name={['criminal', 'firstName']}
              label='ชื่อ'
              rules={[
                {
                  required: isCriminal,
                  message: 'กรุณากรอกข้อมูล',
                },
              ]}
            >
              <Input placeholder='ชื่อ' disabled={modeCriminal === 'EDIT'} />
            </Form.Item>
          </Col>
          <Col xs={24} md={10}>
            <Form.Item
              name={['criminal', 'lastName']}
              label='นามสกุล'
              rules={[
                {
                  required: isCriminal,
                  message: 'กรุณากรอกข้อมูล',
                },
              ]}
            >
              <Input placeholder='นามสกุล' disabled={modeCriminal === 'EDIT'} />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12}>
            <Form.Item
              name={['criminal', 'oldFirstName']}
              label='ชื่อเดิม'
              rules={[
                {
                  // required: isCriminal,
                  message: 'กรุณากรอกข้อมูล',
                },
              ]}
            >
              <Input
                placeholder='ชื่อเดิม (ถ้ามี)'
                disabled={modeCriminal === 'EDIT'}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              name={['criminal', 'oldLastName']}
              label='นามสกุลเดิม'
              rules={[
                {
                  // required: isCriminal,
                  message: 'กรุณากรอกข้อมูล',
                },
              ]}
            >
              <Input
                placeholder='นามสกุลเดิม (ถ้ามี)'
                disabled={modeCriminal === 'EDIT'}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12}>
            <Form.Item
              name={['criminal', 'idCardNo']}
              label='เลขประจำตัวประชาชน'
              rules={[
                {
                  required: isCriminal,
                  validator: checkValidateCitizen,
                },
              ]}
            >
              <Input
                placeholder='เลขประจำตัวประชาชน'
                disabled={modeCriminal === 'EDIT'}
                onKeyPress={(event) => validateNumberOnly(event)}
                maxLength={13}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              name={['criminal', 'idCardConfirm']}
              label='ยืนยันเลขประจำตัวประชาชน'
              rules={[
                {
                  required: isCriminal,
                  validator: checkValidateCitizen,
                },
              ]}
            >
              <Input
                placeholder='ยืนยันเลขประจำตัวประชาชน'
                disabled={modeCriminal === 'EDIT'}
                onKeyPress={(event) => validateNumberOnly(event)}
                maxLength={13}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 16]}>
          <Col xs={24} md={12}>
            <Form.Item
              name={['criminal', 'dob']}
              label='วันทีเกิด'
              rules={[
                {
                  required: isCriminal,
                  message: 'กรุณากรอกข้อมูล',
                },
              ]}
            >
              <MUIDatePicker
                placeholder='วันที่'
                // disabled={modeCriminal === "EDIT"}
                disabled={modeCriminal === 'EDIT'}
                minDate={moment().subtract(100, 'y').toDate()}
                value={form.getFieldsValue().dob || moment()}
                onChange={(e) => onChangeBirthday(e)}
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={6}>
            <Form.Item
              name={['criminal', 'gender']}
              label='เพศ'
              rules={[
                {
                  required: isCriminal,
                  message: 'กรุณากรอกข้อมูล',
                },
              ]}
            >
              <Select
                showSearch
                disabled={modeCriminal === 'EDIT'}
                filterOption={(input, option: any) =>
                  option.label.indexOf(input.toLowerCase()) >= 0
                }
                // onChange={onGenderChange}
                options={sexes}
                placeholder='กรุณาระบุเพศ'
              ></Select>
            </Form.Item>
          </Col>
          <Col xs={24} md={6}>
            <Form.Item name={'age'} label='อายุ'>
              <Input placeholder='0' disabled />
            </Form.Item>
          </Col>
        </Row>
        {/* <Row gutter={[16, 16]}>
          <Col
            xs={24}
            sm={12}
          >
            <Form.Item
              name={['criminal', 'fatherName']}
              label='ชื่อ-นามสกุล บิดา'
              rules={[
                {
                  required: isCriminal,
                  message: 'กรุณากรอกข้อมูล',
                },
              ]}
            >
              <Input
                placeholder='ชื่อ-นามสกุล บิดา'
                disabled={modeCriminal === 'EDIT'}
              />
            </Form.Item>
          </Col>
          <Col
            xs={24}
            sm={12}
          >
            <Form.Item
              name={['criminal', 'motherName']}
              label='ชื่อ-นามสกุล มารดา'
              rules={[
                {
                  required: isCriminal,
                  message: 'กรุณากรอกข้อมูล',
                },
              ]}
            >
              <Input
                placeholder='ชื่อ-นามสกุล มารดา'
                disabled={modeCriminal === 'EDIT'}
              />
            </Form.Item>
          </Col>
        </Row> */}
        <Form.Item
          name={['address', 'addressNo']}
          label='ที่อยู่ปัจจุบัน'
          rules={[
            {
              required: isCriminal,
              message: 'กรุณากรอกข้อมูล',
            },
          ]}
        >
          <Input
            placeholder='ที่อยู่ปัจจุบัน'
            disabled={modeCriminal === 'EDIT'}
          />
        </Form.Item>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12}>
            <Form.Item
              name={['address', 'postCode']}
              label='รหัสไปรษณีย์'
              rules={[
                {
                  required: isCriminal,
                  message: 'กรุณากรอกข้อมูล',
                },
              ]}
            >
              <Select
                showSearch
                disabled={modeCriminal === 'EDIT'}
                onChange={onPostalCodeCriminalChange}
                options={postalCodesCriminal}
                placeholder='รหัสไปรษณีย์'
              ></Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              name={['address', 'subDistrict']}
              label='แขวง / ตำบล'
              rules={[
                {
                  required: isCriminal,
                  message: 'กรุณากรอกข้อมูล',
                },
              ]}
            >
              <Select
                showSearch
                disabled={modeCriminal === 'EDIT'}
                filterOption={(input, option: any) =>
                  option.label.indexOf(input.toLowerCase()) >= 0
                }
                onChange={onSubCityCriminalChange}
                options={subCitiesCriminal}
                placeholder='แขวง / ตำบล'
              ></Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12}>
            <Form.Item
              name={['address', 'district']}
              label='เขต / อำเภอ'
              rules={[
                {
                  required: isCriminal,
                  message: 'กรุณากรอกข้อมูล',
                },
              ]}
            >
              <Select
                showSearch
                disabled={modeCriminal === 'EDIT'}
                filterOption={(input, option: any) =>
                  option.label.indexOf(input.toLowerCase()) >= 0
                }
                onChange={onCityCriminalChange}
                options={citiesCriminal}
                placeholder='เขต / อำเภอ'
              ></Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item name={['address', 'province']} label='จังหวัด'>
              <Select
                showSearch
                disabled={modeCriminal === 'EDIT'}
                filterOption={(input, option: any) =>
                  option.label.indexOf(input.toLowerCase()) >= 0
                }
                options={statesCriminal}
                placeholder='จังหวัด'
              ></Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={8}>
            <Form.Item
              name={['criminal', 'phoneNo']}
              label='หมายเลขโทรศัพท์ติดต่อได้'
              rules={[
                {
                  required: isCriminal,
                  validator: validatePhoneNumber,
                },
              ]}
            >
              <Input
                placeholder='หมายเลขโทรศัพท์ติดต่อได้'
                disabled={modeCriminal === 'EDIT'}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item name={['criminal', 'email']} label='อีเมล'>
              <Input placeholder='อีเมล' disabled={modeCriminal === 'EDIT'} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item name={['criminal', 'lineId']} label='Line ID'>
              <Input
                placeholder='Line ID'
                maxLength={10}
                disabled={modeCriminal === 'EDIT'}
              />
            </Form.Item>
          </Col>
        </Row>
        <div className={styles.header}>
          * ใช้เพื่อเป็นข้อมูลในการติดต่อ กรณีพบปัญหา
        </div>
        <div
          style={{
            border: '1px solid #d9d9d9',
            borderRadius: '4px',
            padding: '10px',
          }}
        >
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={12}>
              <span>เคยมีประวัติต้องข้อหาคดีอาญาหรือไม่</span>
              <Radio.Group
                name={'existingCriminalRecord'}
                disabled={modeCriminal === 'EDIT'}
                onChange={changeExistingCriminalRecordValue}
                value={isExistingCriminalRecord}
                style={{ paddingTop: '10px' }}
              >
                <Radio value={false}>ไม่เคยมีประวัติต้องหาคดีอาญา</Radio>
                <Radio value={true}>เคยมีประวัติต้องหาคดีอาญา</Radio>
              </Radio.Group>
            </Col>
          </Row>
          {/* <div style={{ padding: "15px 0px" }}>
            ข้าพเจ้ามีความประสงค์จะขอตรวจสอบประวัติของตนเองตาม พ.ร.บ.
            ข้อมมูลข่าวสารทางราชการ พ.ศ. 2540 ม.25
          </div> */}
          {/* <Row gutter={[16, 16]} style={{ paddingBottom: "25px" }}>
            <Col span={24}>
              <Radio.Group>
                <Radio value={1}>เพื่อสมัครงานเอกชน</Radio>
                <Radio value={2}>ต้องการตรวจสอบประวัติตนเอง</Radio>
                <Radio value={3}>ขออนุญาติเข้าพื้นที่หวงห้าม</Radio>
                <Radio value={4}>อื่นๆ โปรดระบุ</Radio>
              </Radio.Group>
            </Col>
          </Row> */}
          {/* <Row gutter={[16, 16]}>
            <Col span={6}>
              <Form.Item
                name={["technician", "name"]}
                label="ระบุจำนวนรายการประวัติ"
                rules={[
                  {
                    required: true,
                    message: "กรุณากรอกข้อมูล",
                  },
                ]}
              >
                <Input placeholder="ชุด" />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name={["technician", "phone"]}
                label="ค่าธรรมเนียม"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input placeholder="บาท" maxLength={10} />
              </Form.Item>
            </Col>
          </Row> */}

          <Row gutter={[16, 16]} style={{ paddingTop: '20px' }}>
            <Col xs={24} sm={12}>
              <Form.Item
                label='ภาพถ่ายบัตรประชาชน (ด้านหน้า)'
                name={'idCardCriminal'}
                rules={[
                  {
                    required: true,
                    message: 'กรุณาอัพโหลดรูป',
                  },
                ]}
              >
                <Upload
                  name='idCardCriminal'
                  disabled={modeCriminal === 'EDIT'}
                  showUploadList={false}
                  customRequest={({ onSuccess }: any) => {
                    onSuccess();
                  }}
                  onPreview={onPreviewIdCard}
                  onChange={onUploadIdCardChange}
                >
                  <Button
                    disabled={modeCriminal === 'EDIT'}
                    style={{ width: '100%', height: '100%' }}
                    icon={<PlusOutlined />}
                  >
                    อัพโหลดรูปภาพ
                  </Button>
                </Upload>
                {idCardfile?.url && (
                  <img
                    src={idCardfile?.url}
                    alt='avatar'
                    style={{
                      maxWidth: '100%',
                      maxHeight: '50%',
                      marginTop: '15px',
                      borderRadius: '15px',
                    }}
                  />
                )}
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label='ถ่ายภาพใบหน้าพร้อมถือบัตรประชาชนคู่กัน'
                name='verifiedImage'
                rules={[
                  {
                    required: true,
                    message: 'กรุณาอัพโหลดรูป',
                  },
                ]}
              >
                <Upload
                  name='verifiedImage'
                  disabled={modeCriminal === 'EDIT'}
                  showUploadList={false}
                  customRequest={({ onSuccess }: any) => {
                    onSuccess();
                  }}
                  onPreview={onPreviewIdVerifiedCard}
                  onChange={onUploadIdVerifiedCardChange}
                >
                  <Button
                    name='verifiedImage'
                    disabled={modeCriminal === 'EDIT'}
                    style={{ width: '100%', height: '100%' }}
                    icon={<PlusOutlined />}
                  >
                    อัพโหลดรูปภาพ
                  </Button>
                </Upload>
                {verifiedImage?.url && (
                  <img
                    src={verifiedImage?.url}
                    alt='avatar'
                    style={{
                      maxWidth: '100%',
                      maxHeight: '100%',
                      marginTop: '15px',
                      borderRadius: '15px',
                    }}
                  />
                )}
              </Form.Item>
            </Col>
          </Row>
        </div>
      </>
    );
  };

  return (
    <>
      <Layout>
        <div className={styles.headerPath}>
          {' '}
          <Link to={`/`}>{'< '} หน้าหลัก</Link>
        </div>
        <div className={styles.header}>สร้างประกาศหางาน</div>
        <Card bordered={false} style={{ width: '100%' }}>
          <div>
            {isLoading ? (
              <div style={{ textAlign: 'center' }}>
                <LoadingOutlined className={styles.loadingIcon} />
              </div>
            ) : (
              <>
                <div className={styles.header}>รายละเอียดข้อมูลช่าง</div>
                <Form
                  name='applyJob'
                  form={form}
                  layout='vertical'
                  initialValues={applyJobData}
                  // initialValues={{ technician: applyJobData, criminal: criminalRecordData  }}
                  onFinish={handleShowUpdateBtnClick}
                >
                  <Form.Item
                    name='serviceCategory'
                    label='หมวดหมู่ (เลือกได้มากกว่า 1 หมวดหมู่)'
                    rules={[
                      {
                        required: true,
                        message: 'กรุณากรอกข้อมูล',
                      },
                    ]}
                  >
                    <Select
                      mode='multiple'
                      style={{ width: '100%' }}
                      placeholder='หมวดหมู่'
                      onChange={handleServiceCategoryChange}
                      options={serviceCategoryOptions}
                    />
                  </Form.Item>
                  <Form.Item
                    name='topic'
                    label='ชื่อประกาศ (ตั้งชื่อให้สอดคล้องกับงานที่รับทำ)'
                    rules={[
                      {
                        required: true,
                        message: 'กรุณากรอกข้อมูล',
                      },
                    ]}
                  >
                    <Input placeholder='ชื่อประกาศ' />
                  </Form.Item>

                  <Form.Item
                    name='description'
                    label='รายละเอียดงาน (อธิบายรูปแบบงานที่รับทำ)'
                  >
                    <Input.TextArea placeholder='รายละเอียดเพิ่มเติม' />
                  </Form.Item>

                  <Row gutter={[16, 16]}>
                    <Col xs={24} sm={12}>
                      <Form.Item
                        name={['technician', 'name']}
                        label='ชื่อจริง'
                        rules={[
                          {
                            required: true,
                            message: 'กรุณากรอกข้อมูล',
                          },
                        ]}
                      >
                        <Input placeholder='ชื่อจริง' />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}>
                      <Form.Item
                        name={['technician', 'lastName']}
                        label='นามสกุล'
                        rules={[
                          {
                            required: true,
                            message: 'กรุณากรอกข้อมูล',
                          },
                        ]}
                      >
                        <Input placeholder='นามสกุล' />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col xs={24} sm={12}>
                      <Form.Item
                        name={['technician', 'email']}
                        label='อีเมล'
                        rules={[
                          {
                            // required: true,
                            message: 'กรุณากรอกข้อมูล',
                          },
                        ]}
                      >
                        <Input placeholder='อีเมล' />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}>
                      <Form.Item
                        name={['technician', 'phone']}
                        label='เบอร์โทร'
                        rules={[
                          {
                            required: true,
                            validator: validatePhoneNumber,
                          },
                        ]}
                      >
                        <Input
                          placeholder='เบอร์โทรศัพท์'
                          onKeyPress={(event) => validateNumberOnly(event)}
                          maxLength={10}
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Form.Item
                    name={['technician', 'address']}
                    label='ที่อยู่'
                    rules={[
                      {
                        required: true,
                        message: 'กรุณากรอกข้อมูล',
                      },
                    ]}
                  >
                    <Input placeholder='ที่อยู่' />
                  </Form.Item>

                  <Row gutter={[16, 16]}>
                    <Col xs={24} sm={12}>
                      <Form.Item
                        name={['technician', 'postCode']}
                        label='รหัสไปรษณีย์'
                        rules={[
                          {
                            required: true,
                            message: 'กรุณากรอกข้อมูล',
                          },
                        ]}
                      >
                        <Select
                          showSearch
                          onChange={onPostalCodeChange}
                          options={postalCodes}
                          placeholder='รหัสไปรษณีย์'
                        ></Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}>
                      <Form.Item
                        name={['technician', 'subDistrict']}
                        label='แขวง / ตำบล'
                        rules={[
                          {
                            required: true,
                            message: 'กรุณากรอกข้อมูล',
                          },
                        ]}
                      >
                        <Select
                          showSearch
                          filterOption={(input, option: any) =>
                            option.label.indexOf(input.toLowerCase()) >= 0
                          }
                          onChange={onSubCityChange}
                          options={subCities}
                          placeholder='แขวง / ตำบล'
                        ></Select>
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={[16, 16]}>
                    <Col xs={24} sm={12}>
                      <Form.Item
                        name={['technician', 'district']}
                        label='เขต / อำเภอ'
                        rules={[
                          {
                            required: true,
                            message: 'กรุณากรอกข้อมูล',
                          },
                        ]}
                      >
                        <Select
                          showSearch
                          filterOption={(input, option: any) =>
                            option.label.indexOf(input.toLowerCase()) >= 0
                          }
                          onChange={onCityChange}
                          options={cities}
                          placeholder='เขต / อำเภอ'
                        ></Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}>
                      <Form.Item
                        name={['technician', 'province']}
                        label='จังหวัด'
                      >
                        <Select
                          showSearch
                          filterOption={(input, option: any) =>
                            option.label.indexOf(input.toLowerCase()) >= 0
                          }
                          options={states}
                          placeholder='จังหวัด'
                        ></Select>
                      </Form.Item>
                    </Col>
                  </Row>

                  {selectedServiceCategory.map((item: any) => {
                    const name = serviceCategoryList.find(
                      (category) => category.value === item
                    );
                    return (
                      <Form.Item
                        key={item}
                        label={`รูปตัวอย่างผลงาน ${name?.label} (อย่างน้อย 3 รูป)`}
                        name={['services', item]}
                        rules={[
                          {
                            required: true,
                            message: 'กรุณาอัพโหลดรูปผลงาน',
                          },
                        ]}
                      >
                        <UploadImages
                          form={form}
                          field={item}
                          files={(filesServices && filesServices[item]) || []}
                          onChangeState={setFilesServices}
                        />
                      </Form.Item>
                    );
                  })}

                  <Form.Item
                    name='idFileList'
                    label='รูปหน้าตรง (รูปโปรไฟล์)'
                    rules={[
                      {
                        required: true,
                        message: 'กรุณาอัพโหลดรูปหน้าตรง (รูปโปรไฟล์)',
                      },
                    ]}
                  >
                    <Upload {...idUploaderProps}>
                      {idFileList.length < 1 && '+ Upload'}
                    </Upload>
                  </Form.Item>

                  <Form.Item
                    name='serviceAreas'
                    label='พื้นที่ให้บริการ'
                    rules={[
                      {
                        required: true,
                        message: 'กรุณาระบุพื้นที่ให้บริการ',
                      },
                    ]}
                  >
                    <ServiceAreaInput
                      ref={areaInputRef}
                      data={serviceAreas}
                      onChange={(val: ServiceAreaType[]) => {
                        // console.log('val...', JSON.stringify(val));
                        setServiceAreas(val);
                      }}
                    />
                  </Form.Item>

                  <Form.Item name='checkbox'>
                    <Checkbox
                      name='isCriminal'
                      disabled={modeCriminal === 'EDIT'}
                      onChange={(e) => onCheckCriminal(e)}
                      checked={isCriminal}
                    >
                      {' '}
                      <span style={{ color: 'red' }}>
                        ข้าพเจ้ายินยอมให้ พร้อมดี
                        เป็นตัวแทนในการส่งตรวจประวัติข้าพเจ้าผ่าน
                        กองทะเบียนประวัติอาชญากร ตรวจสอบ พร้อมจัดเก็บ
                        และเปิดเผยข้อมูลส่วนบุคคลของข้าพเจ้า
                      </span>
                    </Checkbox>
                    {isCriminal && (
                      <>
                        <div
                          className={styles.header}
                          style={{ paddingTop: '20px' }}
                        >
                          ข้อมูลที่ต้องใช้ในการตรวจสอบประวัติ
                        </div>
                        <div className={styles.header}>1. ข้อมูลส่วนตัว</div>
                        <CriminalForm />
                      </>
                    )}
                  </Form.Item>

                  <div style={{ marginTop: '5rem' }}>
                    <Button
                      size='large'
                      type='primary'
                      htmlType='submit'
                      block={blockButton}
                      hidden={mode !== 'CREATE'}
                    >
                      ยืนยันประกาศ
                    </Button>
                    <Button
                      size='large'
                      type='primary'
                      htmlType='submit'
                      block={blockButton}
                      disabled={mode === 'VIEW'}
                      hidden={mode !== 'EDIT' && mode !== 'VIEW'}
                    >
                      อัพเดทประกาศ
                    </Button>
                  </div>
                  <div style={{ paddingTop: '20px' }}>
                    <label hidden={mode !== 'VIEW'}>
                      ** ถ้าต้องการแก้ไขข้อมูล โปรดติดต่อผู้ดูแลระบบ{' '}
                    </label>
                  </div>
                </Form>
                <Modal
                  title='ยืนยันการแก้ไขประกาศงาน'
                  visible={showConfirmUpdate}
                  onOk={handleApplyJob}
                  onCancel={handleHideUpdateBtnClick}
                  okText='ยืนยัน'
                  cancelText='ยกเลิก'
                >
                  <p>เมื่อแก้ไขผู้ดูแลระบบจะทำการตรวจสอบอีกครั้ง</p>
                  <p>ยืนยันการแก้ไขประกาศงาน?</p>
                </Modal>
              </>
            )}
          </div>
        </Card>
      </Layout>
    </>
  );
};

export default ServiceApplyJob;
